<template lang="pug">
  .delivery-options.xs-f-small.max-at-tweak.xs-12(v-if="showSection")
    .delivery-options-inner.xs-12
      .pick-up-options-section.xs-12
        p.bold.upper.xs-f-small.max-at-tweak Get it today:
        ul.xs-f-small.max-at-tweak
          li(v-if="showInStorePickUp") In-store pickup available at our&nbsp;
            a.underline.btn-link(
              id="pdp-available-in-region-link"
              aria-label="colorbar locations"
              :href="locationUrl"
            ) {{ location.neighborhood }} location

          li(v-if="doorDashEligible") Same-day delivery with
            mr-icon.mb-5.doordash-logo(name="doordash" key="doordash" height="0.7em")
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    name: 'DeliveryOptions',
  
    inject: ['getObjProperty'],

    computed: {
      ...mapState('colorbar', ['location']),
      ...mapState('pdp', ['version', 'doorDashEligible']),
      ...mapState('colorbar', ['location']),
      ...mapGetters('colorbar', ['availableAtColorbar']),
      ...mapState('pdp', ['product', 'doorDashEligible']),

      showInStorePickUp() {
        return this.availableAtColorbar(this.product.code);
      },

      showSection() {
        return this.showInStorePickUp || this.doorDashEligible;
      },

      locationUrl() {
        return `/colorbar/locations/${this.getObjProperty(this, 'location.url_key')}`;
      }
    },

    watch: {
      doorDashEligible(val) {
        if (val) {
          this.trackMREvent('Doordash - PDP Viewed');
        }
      },
    },

    mounted() {
      // should be done here because it requires customer data and we have to think on ssr
      this.getDoorDashEligible();
    },

    methods: {
      ...mapActions('pdp', ['getDoorDashEligible']),
    },
  };
</script>

<style lang="stylus">
  .delivery-options
    padding-bottom 1em

    .delivery-options-inner
      border 1px solid ui-color-5
      padding 0.5em 1em
      display flex
      flex-direction column

    &:last-child
      padding-bottom 0

    @media mq-tablet-less
      padding 0 3% 1em 3%

    @media mq-tablet
      padding-left 10%
      padding-right 10%


    @media mq-desktop-plus
      .delivery-options
        margin 0 0 1em 0

  .pick-up-options-section
    .doordash-logo
      color #ff3008 !important
      margin-bottom 0px !important
      margin-left 5px

    ul
      list-style disc
      padding-left 0.1em
      margin-top 0.25em
      margin-bottom 0.5em
      margin-left 1em

      li
        &:last-child
          margin-top 0.5em

        img
          margin-left 5px
          width 80px
    @media mq-desktop-plus
      ul
        padding-left inherit
        margin-left 1.25em

        li
          img
            margin-left 10px
</style>